import { createApp } from 'vue';

import Reviews from '../components/agent/reviews.vue';

// Mounts the agent review carousel on agent detail pages.
const reviewsElement = document.getElementById('reviews');

if (reviewsElement) {
	const app = createApp({
		template: `
			<Reviews />
		`,
		components: {
			Reviews
		}
	});

	app.config.compilerOptions.whitespace = 'preserve';
	app.mount(reviewsElement);
}
